export default "__VITE_ASSET__e1ee19a4__"